"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormatAndLinkify = exports.Linkify = exports.Sanitize = exports.Format = void 0;
const Format_1 = require("./Format");
const LinkGenerator_1 = require("./LinkGenerator");
const Linkify_1 = require("./Linkify");
const Sanitize_1 = require("./Sanitize");
const Format = (input) => {
    return Format_1.default(Sanitize_1.default(input));
};
exports.Format = Format;
const Sanitize = (input) => {
    return Sanitize_1.default(input);
};
exports.Sanitize = Sanitize;
const Linkify = (input, domain) => {
    return Linkify_1.default(Sanitize_1.default(input), LinkGenerator_1.StandardLinkGenerator(domain));
};
exports.Linkify = Linkify;
const FormatAndLinkify = (input, domain) => {
    return Linkify_1.default(Format_1.default(Sanitize_1.default(input)), LinkGenerator_1.StandardLinkGenerator(domain));
};
exports.FormatAndLinkify = FormatAndLinkify;
